import { Component, DoCheck, Input } from '@angular/core';
import { AufnahmePunktDocument, Baumart, bodenformString, isB, isG, isM, roundToNumber } from '../../../data-model';
import { EvaluationService } from '../../evaluation.service';
import { ValidationService } from '../../validation.service';
import { DataService } from 'src/app/data.service';

@Component({
    standalone: false,
    selector: 'bp-bohrpunkt-weitere',
    templateUrl: './bohrpunkt-weitere.component.html',
    styleUrls: ['../hl-table.component.css'],
    
})
export class BohrpunktWeitereComponent implements DoCheck {

  @Input() bp!: AufnahmePunktDocument;
  @Input() printView!: boolean;

  roundToNumber = roundToNumber;

  constructor(
    private ds: DataService,
    private es: EvaluationService,
    private vs: ValidationService,
  ) { }

  ngDoCheck(): void {
    this.es.setContext(this.bp);
    this.vs.setContext(this.bp);
  }

  baumarten(): string {
    if (typeof this.bp.extendedHeader.baumarten === 'string') return this.bp.extendedHeader.baumarten;

    const baumarten = this.bp.extendedHeader.baumarten as Baumart[];
    let bas = '';
    for (const ba of baumarten) bas += ba.art + '';

    return bas;
  }

  adresse(): string {
    const a = this.bp.header.adresse;
    return '${a.abteilung}${a.unterabteilung}${a.teilflaeche}';
  }

  hasGemarkung(): boolean {
    return !!this.bp.header.adresse.gemarkung || !!this.bp.header.adresse.flur || !!this.bp.header.adresse.flurstueck;
  }

  isB(): boolean {
    return isB(this.bp);
  }

  isG(): boolean {
    return isG(this.bp);
  }

  isM(): boolean {
    return isM(this.bp);
  }

  bodenformString(which: string) {
		return bodenformString(this.bp.header.bodenform, which);
  }

  qualityString(quality: number) {
    const e = this.ds.hardData.Qualitätsstufen.find((entry: any) => entry.id === quality);
    return e ? e.name : "unbekannt";
  }

  hauptbodenform = () => this.bodenformString('hbf');
  feinbodenform = () => this.bodenformString('fbf');

}
